// Modules
import { useCallback } from 'react'
import axios from 'axios'

// Hooks
import useNotices from 'hooks/system/useNotices'

// Helpers
import { getAuthorizationHeader, getTeam } from 'helpers/authentication'
import { getLanguage, getTheme } from 'helpers/system'

// Constants
import { LOGIN_URL } from 'constants/environment'

// Hook: External > Navigate with parameters
function useNavigateWithParameters () {
	// Data
	const { addNotice } = useNotices()

	// Function (Memoized)
	const navigateWithParameters = useCallback(async (url, tokenType) => {
		const redirectURL = !!url ? new URL(url) : null
		try {
			const { data } = await axios({
				data: { app: tokenType },
				headers: { ...getAuthorizationHeader() },
				method: 'POST',
				url: `${LOGIN_URL}/app`
			})
			if (!!data.accessToken && !!data.refreshToken) {
				redirectURL.searchParams.set('token', data.accessToken)
				redirectURL.searchParams.set('refresh', data.refreshToken)
				redirectURL.searchParams.set('team', getTeam())
				redirectURL.searchParams.set('language', getLanguage())
				redirectURL.searchParams.set('theme', getTheme())
				window.location.href = redirectURL.href
			}
		} catch (error) {
			addNotice({ code: 'client.applicationTokenFetchingError', log: error, type: 'error' })
		}
	}, [addNotice])

	// Response
	return { navigateWithParameters }
}

// Export
export default useNavigateWithParameters
